<template>
    <div class="parking-space-tree-container">
        <el-dialog :visible.sync="dialogVisible" :title="$t('parkingSpaceTree.title')" width="420px"
            custom-class="center-dialog" :modal="true" append-to-body>
            <div class="tree-search-box" v-if="treeData.length > 3">
                <el-input v-model="filterText" size="small" :placeholder="$t('parkingSpaceTree.filterPlaceholder')" clearable />
            </div>
            <el-tree ref="parkingTree" :data="treeData" :props="defaultProps" node-key="id" highlight-current
                :expand-on-click-node="false" :filter-node-method="filterNode" @node-click="handleNodeClick">
                <span slot-scope="{ node, data }" class="custom-tree-node">
                    <span class="tree-label">{{ node.label }}</span>
                    <span v-if="data.extra" class="tree-extra">{{ data.extra }}</span>
                </span>
            </el-tree>
        </el-dialog>
    </div>
</template>

<script>
import { listParkingAreas, queryParkingSpaces } from '@/api/car/hireParkingSpaceApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
    name: 'ParkingSpaceTree',
    props: {
        parkingSpaceFlag: {
            type: String,
            default: 'F'
        }
    },
    data() {
        return {
            dialogVisible: false,
            filterText: '',
            treeData: [],
            defaultProps: {
                children: 'children',
                label: 'text',
                isLeaf: 'isLeaf'
            }
        }
    },
    watch: {
        filterText(val) {
            this.$refs.parkingTree.filter(val)
        }
    },
    methods: {
        open() {
            this.dialogVisible = true
            this.filterText = ''
            this.loadParkingAreas()
        },

        async loadParkingAreas() {
            try {
                const communityId = getCommunityId()
                const { parkingAreas } = await listParkingAreas({
                    page: 1,
                    row: 50,
                    communityId
                })

                if (parkingAreas && parkingAreas.length > 0) {
                    // 显式设置 isLeaf: false 确保 el-tree 渲染展开箭头
                    this.treeData = parkingAreas.map(area => ({
                        id: `pa_${area.paId}`,
                        paId: area.paId,
                        text: `🏠 ${area.num}`,
                        children: [],
                        isLeaf: false
                    }))
                } else {
                    this.treeData = []
                }
            } catch (error) {
                console.error('加载停车场区域失败:', error)
                this.$message.error('加载停车场失败')
            }
        },

        async handleNodeClick(data, node) {
            if (data.id.startsWith('pa_')) {
                // 只在第一次展开时加载子节点
                if (!node.expanded && (!data.children || data.children.length === 0)) {
                    await this.loadSpaces(data.paId, node)
                }
            } else if (data.id.startsWith('ps_')) {
                this.dialogVisible = false
                this.$emit('select-parking-space', {
                    psId: data.psId,
                    psName: data.psName,
                    areaNum: data.areaNum,
                    num: data.num
                })
            }
        },

        async loadSpaces(paId, node) {
            try {
                const communityId = getCommunityId()
                const { parkingSpaces } = await queryParkingSpaces({
                    paId,
                    communityId,
                    page: 1,
                    row: 1000,
                    state: this.parkingSpaceFlag
                })

                if (parkingSpaces && parkingSpaces.length > 0) {
                    // 车位从小到大排序
                    const sorted = [...parkingSpaces].sort((a, b) => {
                        const aNum = parseInt(a.num)
                        const bNum = parseInt(b.num)
                        if (!isNaN(aNum) && !isNaN(bNum)) {
                            return aNum - bNum
                        }
                        return (a.num || '').localeCompare(b.num || '')
                    })

                    const spaceNodes = sorted.map(space => {
                        const occupied = space.ownerName || space.carNum
                        return {
                            id: `ps_${space.psId}`,
                            psId: space.psId,
                            psName: `${space.areaNum}-${space.num}`,
                            areaNum: space.areaNum,
                            num: space.num,
                            text: space.num,
                            extra: occupied ? `[${occupied}]` : '',
                            isLeaf: true
                        }
                    })

                    // 显式标记父节点为非叶子节点
                    this.$set(node.data, 'isLeaf', false)
                    this.$set(node.data, 'children', spaceNodes)
                }
            } catch (error) {
                console.error('加载停车位失败:', error)
                this.$message.error('加载停车位失败')
            }
        },

        filterNode(value, data) {
            if (!value) return true
            return data.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
        }
    }
}
</script>

<style lang="scss" scoped>
.parking-space-tree-container ::v-deep .center-dialog {
    .el-dialog {
        margin-top: 15vh !important;
        border-radius: 8px !important;
    }

    .el-dialog__header {
        padding: 16px 20px !important;
        border-bottom: 1px solid #eee;
    }

    .el-dialog__body {
        padding: 10px 20px !important;
        max-height: 55vh;
        overflow-y: auto;
    }
}

.tree-search-box {
    margin-bottom: 12px;
}

.custom-tree-node {
    display: inline-flex;
    align-items: center;
    width: 100%;
}

.tree-extra {
    color: #999;
    font-size: 12px;
    margin-left: 6px;
}
</style>
